import React from 'react';
import styled from 'styled-components';

const StyledGoogleMap = styled.div`
    overflow:hidden;
    margin: 0 auto;
    padding-bottom: 11.33%;
    position:relative;
    height:0;
    
    @media only screen and (max-width: 800px) {
    padding-bottom: 39.33%;
    }
    
    iframe {
    position:absolute;
    left:0;
    top:0;
    height:100% !important;
    width:100% !important;
    border:0;
    } 
`;

function GoogleMap(props) {
  return (
    <div>
      <StyledGoogleMap>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d81408.51163205413!2d-74.01811181152198!3d40.68802491095108!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sil!4v1578348617774!5m2!1sen!2sil"
          width="600"
          height="450"
          frameBorder="0"
          allowFullScreen=""
        />
      </StyledGoogleMap>
    </div>
  );
}

export default GoogleMap;
